import Card from 'antd/es/card';
import styled from 'styled-components';

import Header from './Header';

const CardWrapper = styled.div`
  display: flex;
  margin: auto;
`;

const StyledCard = styled(Card)`
  width: 400px;
  border-radius: 8px;
  margin: auto;

  .ant-card-body {
    padding: 16px 24px;
  }
`;

const UnauthCard = ({ children, ...props }: React.PropsWithChildren) => {
  return (
    <CardWrapper>
      <StyledCard {...props}>
        <Header />
        {children}
      </StyledCard>
    </CardWrapper>
  );
};

export default UnauthCard;
